import SiteLayout from './siteLayout.component';

export default SiteLayout;